/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProvidersEnum } from './cloudProvidersEnum';
import { IrrSaasCapabilities } from './irrSaasCapabilities';


export interface TenantDeploymentSpec { 
    /**
     * Name of deployment
     */
    name?: string;
    provider: CloudProvidersEnum;
    /**
     * Cloud Provider Region ID
     */
    region: string;
    /**
     * Requested Deployment version
     */
    version?: string;
    authorize_vcf_app?: boolean;
    authorize_vmc_app?: boolean;
    capabilities?: IrrSaasCapabilities;
}
export namespace TenantDeploymentSpec {
}


